// The models a Claude Code step can run, passed to the CLI as `claude --model <value>`. A
// family alias follows that family's newest model; an id pins one version.
export interface ModelChoice {
  value: string;
  name: string;
  /** An alias that moves to the family's newest model. */
  latest?: boolean;
}

export const CLAUDE_MODELS: ModelChoice[] = [
  { value: "opus", name: "Opus", latest: true },
  { value: "sonnet", name: "Sonnet", latest: true },
  { value: "haiku", name: "Haiku", latest: true },
  { value: "claude-fable-5-1", name: "Fable 5.1" },
  { value: "claude-opus-5-5", name: "Opus 5.5" },
  { value: "claude-sonnet-5-5", name: "Sonnet 5.5" },
  { value: "claude-haiku-4-5-20251001", name: "Haiku 4.5" },
];

export interface ModelLabels {
  platformDefault: string;
  modelLatest: (name: string) => string;
  modelCustom: (id: string) => string;
}

/**
 * The dropdown's options: the platform default (empty value), the known models, and the
 * node's current model when it is none of them, so a saved workflow never loses its value.
 */
export function modelOptions(current: string | undefined, t: ModelLabels): { value: string; label: string }[] {
  const known = CLAUDE_MODELS.map((m) => ({ value: m.value, label: m.latest ? t.modelLatest(m.name) : `${m.name} · ${m.value}` }));
  const custom = current && !CLAUDE_MODELS.some((m) => m.value === current) ? [{ value: current, label: t.modelCustom(current) }] : [];
  return [{ value: "", label: t.platformDefault }, ...known, ...custom];
}
